import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { Button } from 'ui-components/components/button';
import PhoneIcon from '../../../../../svgs/help-desk-support-phone-icon.svg';
import ChatIcon from '../../../../../svgs/help-desk-support-chat-icon.svg';
import EmailIcon from '../../../../../svgs/help-desk-support-email-icon.svg';
import Global from '../../../../../store/global-selectors';
import { US } from '../../../../../constants/country-codes';
import { OpenSierraSource } from '../../../../../global/support-chat/open-sierra-in-zendesk';
import useSupportChatItem from '../../../../../components/app-header/help-menu-dropdown/hooks/use-support-chat-item';
import getPhoneSupportMetadata from '../../../../../components/app-header/help-menu-dropdown/phone-support-service';
import { useIsSellerInTrial } from '../../../../../hooks/use-is-seller-in-trial';
import { emptyObject } from 'ui-components/default-props/empty';
import { Segment } from '../../../../../services/analytics-services/segment';
import { WIZARD_HELP_CALL_CLICKED, WIZARD_HELP_CHAT_CLICKED, WIZARD_HELP_EMAIL_CLICKED } from '../../../../../constants/analytics-events';
import { getSupportOnlineFormLink } from '../../../../../utils/support-online-form-link';
import messages from './messages';
import style from './style.module.less';

export const FTUHelpCenter = () => {
  const intl = useIntl();
  const supportCountry = useSelector(Global.selectSellerHomeCountry) || US;
  const isSellerInTrial = useIsSellerInTrial();
  const subscriptionPlanInfo = useSelector(Global.selectSellerSubscriptionPlanInfo) || emptyObject;
  const { trialEndDate } = subscriptionPlanInfo;

  const supportChatItem = useSupportChatItem(OpenSierraSource.FtuWizardHelp);

  const phoneSupportData = getPhoneSupportMetadata(supportCountry, isSellerInTrial, trialEndDate);

  const handleCallClick = () => {
    Segment.trackEvent(WIZARD_HELP_CALL_CLICKED, {
      helpType: 'call',
    });
  };

  const handleChatClick = (e) => {
    Segment.trackEvent(WIZARD_HELP_CHAT_CLICKED, {
      helpType: 'chat',
    });
    if (supportChatItem.onClick) {
      supportChatItem.onClick(e);
    }
  };

  const handleEmailClick = () => {
    Segment.trackEvent(WIZARD_HELP_EMAIL_CLICKED, {
      helpType: 'email',
    });
    window.open(getSupportOnlineFormLink(supportCountry), '_blank', 'noopener,noreferrer');
  };

  return (
    <FlexColumn className={style['ftu-help-center']}>
      <div className={style['help-center-icon']} />
      <FlexColumn className={style['help-center-text']}>
        <Text className={style['help-center-title']} textType={TextType.H4} value={messages.title} />
        <Text className={style['help-center-description']} textType={TextType.Paragraph} value={messages.description} />
      </FlexColumn>
      <FlexColumn className={style['help-center-buttons']}>
        {phoneSupportData && (
          <Button className={style['help-center-button']} href={phoneSupportData.url} onClick={handleCallClick} theme='tertiary'>
            <FlexRow className={style['button-content']}>
              <img alt={intl.formatMessage(messages.phoneIconAlt)} className={style['button-icon']} src={PhoneIcon} />
              <FormattedMessage {...messages.callUs} />
            </FlexRow>
          </Button>
        )}

        {supportChatItem && (
          <Button className={style['help-center-button']} onClick={handleChatClick} theme='tertiary'>
            <FlexRow className={style['button-content']}>
              <img alt={intl.formatMessage(messages.chatIconAlt)} className={style['button-icon']} src={ChatIcon} />
              <FormattedMessage {...messages.chatWithUs} />
            </FlexRow>
          </Button>
        )}

        <Button className={style['help-center-button']} onClick={handleEmailClick} theme='tertiary'>
          <FlexRow className={style['button-content']}>
            <img alt={intl.formatMessage(messages.emailIconAlt)} className={style['button-icon']} src={EmailIcon} />
            <FormattedMessage {...messages.emailSupport} />
          </FlexRow>
        </Button>
      </FlexColumn>
    </FlexColumn>
  );
};
